module.exports = __webpack_public_path__ + "static/media/stockhausen_haut_18.2fb0c859.jpg";